"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
/**
 * Return random generated id
 */
function _default() {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
}
//# sourceMappingURL=randomId.js.map